import { OnChanges } from '@angular/core';
import { Component, Input } from '@angular/core';
import { BankAccount, EnumHelper, HorizontalListData } from 'common';
import { TransferBankAccountWidgetAdapter } from './transfer-bank-account-widget.data';
import { BankAccountRole } from '../bank-account.model';

@Component({
    selector: 'ifp-transfer-bank-account-widget',
    templateUrl: './transfer-bank-account-widget.component.html',
    styleUrls: ['./transfer-bank-account-widget.component.scss'],
    providers: [TransferBankAccountWidgetAdapter],
    standalone: false
})
export class TransferBankAccountWidgetComponent implements OnChanges {
  readonly BankAccountRole = BankAccountRole;

  @Input()
  bank: BankAccount;

  @Input()
  type: BankAccountRole;

  title: string;
  listItems: HorizontalListData[];

  constructor(private readonly adapter: TransferBankAccountWidgetAdapter) {}

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.bank);
    this.title = EnumHelper.getNameFromValue(BankAccountRole, this.type) + ' bank';
  }
}
